import {
  ActivityIcon,
  HeartIcon,
  HeartRangeMetricIcon,
  MeditationIcon,
  MoonIcon,
  WellnessIcon,
} from '@jouzen/ecom-components';
import { type HTMLAttributeAnchorTarget } from 'react';
import type { MessageKey } from 'types/LocaleMessageKey';
import type { SVGIconComponent } from 'types/svgr';

export interface Slide {
  button: {
    href: string;
    target?: HTMLAttributeAnchorTarget;
  };
  category: string;
  id: number;
  image: {
    alt: string;
    src: string;
  };
  tag: {
    label: MessageKey;
    icon: SVGIconComponent;
  };
  title: MessageKey;
}

export const sliderContentOreo = (): Slide[] => [
  {
    button: { href: '/sleep-and-rest' },
    category: 'sleep',
    id: 0,
    image: {
      alt: 'woman_sleeping_image_alt',
      src: 'why-oura/oreo/slide-1-sleep',
    },
    tag: {
      label: 'sleep_rest_tag',
      icon: MoonIcon as SVGIconComponent,
    },
    title: 'best_sleep_of_life',
  },
  {
    button: { href: '/heart-health' },
    category: 'heart_health',
    id: 1,
    image: {
      alt: 'man_lying_down_alt',
      src: 'why-oura/oreo/slide-2-heart',
    },
    tag: {
      label: 'heart_health_tag',
      icon: HeartIcon as SVGIconComponent,
    },
    title: 'listen_to_heart',
  },
  {
    button: {
      href: '/activity-and-movement',
    },
    category: 'activity',
    id: 2,
    image: {
      alt: 'man_exercise_alt',
      src: 'why-oura/oreo/slide-3-activity',
    },
    tag: {
      label: 'fitness_tag',
      icon: ActivityIcon as SVGIconComponent,
    },
    title: 'fitness_goals_focus',
  },
  {
    button: {
      href: `https://ouraring.com/blog/category/health/`,
      target: '_blank',
    },
    category: 'wellness',
    id: 3,
    image: {
      alt: 'heart_health_family_alt',
      src: 'why-oura/oreo/slide-4-wellness',
    },
    tag: {
      label: 'wellness_tag',
      icon: WellnessIcon as SVGIconComponent,
    },
    title: 'live_longer_healthier',
  },
  {
    button: {
      href: '/womens-health',
    },
    category: 'womens_health',
    id: 4,
    image: {
      alt: 'science_and_research_card_three_alt',
      src: 'why-oura/oreo/slide-5-womens',
    },
    tag: {
      label: 'womens_health_tag',
      icon: HeartRangeMetricIcon as SVGIconComponent,
    },
    title: 'ins_outs_womens_health',
  },
  {
    button: {
      href: '/stress',
    },
    category: 'stress',
    id: 5,
    image: {
      alt: 'woman_park_alt',
      src: 'why-oura/oreo/slide-6-stress',
    },
    tag: {
      label: 'stress_tag',
      icon: MeditationIcon as SVGIconComponent,
    },
    title: 'stress_to_test',
  },
];
